import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const painsPitaFourPizza: Recipe = {
  slug: 'pains-pita-four-pizza',
  title: 'Pains pita au four à pizza',
  category: 'salé',
  description:
    'Des pains pita très moelleux, préparés avec une fermentation lente au réfrigérateur et cuits quelques minutes sur la sole du four à pizza.',
  image: image('pains-pita-four-pizza'),
  tags: ['pain', 'four à pizza', 'fermentation lente'],
  meta: [
    { label: 'Rendement', value: '8 pitas' },
    { label: 'Fermentation', value: '10 à 18 h au réfrigérateur' },
    { label: 'Cuisson', value: 'four à pizza à 300 °C' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('farine', 'farine T55', '500 g de farine T55', {
        amount: 500,
        unit: 'g',
        shoppingKey: 'farine',
      }),
      ingredient('eau', 'eau', '320 g d’eau', { amount: 320, unit: 'g', shoppingKey: 'eau' }),
      ingredient('sel', 'sel', '10 g de sel', { amount: 10, unit: 'g', shoppingKey: 'sel' }),
      ingredient('levure', 'levure boulangère sèche', '4 g de levure boulangère sèche', {
        amount: 4,
        unit: 'g',
        shoppingKey: 'levure sèche',
      }),
      ingredient('huile', 'huile d’olive', '15 g d’huile d’olive', {
        amount: 15,
        unit: 'g',
        shoppingKey: 'huile d’olive',
      }),
    ]),
  ],
  steps: [],
  stepGroups: [
    {
      title: 'La veille',
      steps: [
        'Tout mettre dans le bol du KitchenAid et pétrir pendant 7 à 10 minutes, jusqu’à obtenir une pâte lisse et souple.',
        'Couvrir et laisser reposer 30 minutes à température ambiante.',
        'Bouler sans trop serrer, puis placer la pâte dans un récipient légèrement huilé. Couvrir hermétiquement et mettre au réfrigérateur pour 10 à 18 heures.',
      ],
    },
    {
      title: 'Le jour même',
      steps: [
        'Sortir la pâte du réfrigérateur environ 1 h 30 à 2 h avant la cuisson.',
        'Diviser en 8 pâtons d’environ 105 g et former des boules.',
        'Déposer les boules sur un plan légèrement fariné, couvrir et attendre 1 h à 1 h 30. Les pâtons n’ont pas besoin de doubler de volume : ils doivent surtout devenir souples, détendus et légèrement gonflés.',
        'À l’aide d’un rouleau, étaler chaque pâton en un disque d’environ 10 à 12 cm de diamètre et 3 à 4 mm d’épaisseur. Laisser reposer 15 à 20 minutes à couvert.',
        'Cuire dans le four à pizza à 300 °C.',
        'Déposer immédiatement les pitas cuites les unes sur les autres et les envelopper dans un torchon propre. La vapeur ainsi conservée les garde particulièrement souples et moelleuses. On peut aussi les stocker dans le four traditionnel fermé (non chauffé).',
      ],
    },
  ],
  note: 'La pâte peut sans problème rester jusqu’à environ 24 heures au réfrigérateur.',
}
